import { Injectable } from '@angular/core';
import { patchState, signalState } from '@ngrx/signals';
import { AuthUserProfile } from '@sprint-expert-manager/app/core/auth/auth-user-profile';

interface AuthUserProfileCoreState {
  content: AuthUserProfile;
  isLoading: boolean;
  isLoaded: boolean;
  errorMessage: string;
}

const initialState: AuthUserProfileCoreState = {
  content: undefined,
  isLoading: false,
  isLoaded: false,
  errorMessage: '',
};

@Injectable({
  providedIn: 'root',
})
export class AuthUserProfileCoreStore {
  readonly state = signalState(initialState);
  readonly content$$ = this.state.content;
  readonly isLoading$$ = this.state.isLoading;
  readonly isLoaded$$ = this.state.isLoaded;
  readonly errorMessage$$ = this.state.errorMessage;

  constructor() {}

  setAuthUserProfile(authUserProfile: AuthUserProfile) {
    patchState(this.state, {
      content: authUserProfile,
      isLoading: false,
      isLoaded: true,
      errorMessage: '',
    });
  }
}
